/**
 * 
 * key
 * 
 */


const key = 'ZW1wbG95ZWVfcm9sZXNfYW5kX3Jlc3BvbnNpYmlsaXRpZXM='

export default key 